import { useTranslation } from 'react-i18next';
import privacyHtmlByLocale from '../../assets/privacy/privacy-html.json';

export const TRAVELLER_PRIVACY_I18N_KEY = 'traveller_privacy_sections';

export const useTravellerPrivacyHtml = (): string | null => {
  const { i18n, t } = useTranslation();
  const html = privacyHtmlByLocale[i18n.language as keyof typeof privacyHtmlByLocale];

  if (html) {
    return html;
  }

  const translatedSections = t(TRAVELLER_PRIVACY_I18N_KEY, {
    returnObjects: true
  }) as unknown;

  if (Array.isArray(translatedSections)) {
    return translatedSections.join('');
  }

  return privacyHtmlByLocale['en-GB'];
};
